import axios from "axios";
import router from "../router";
import { MessageBox } from "element-ui";
export const baseURL = "https://www.cifujijin.com";

// 免登录接口
const noLoginList = ["/api/mm/telcode", "/api/mm/login", "/api/mm/baseInfo"];

export const service = axios.create({
  baseURL,
  timeout: 1000000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 判断如果不是登录和获取验证码接口，则请求头添加token字段
    if (!noLoginList.includes(config.url)) {
      // 获取用户登录后的token
      const vuex = JSON.parse(sessionStorage.getItem("vuex")) || "";
      config.headers["token"] = vuex.token;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做些什么，例如处理状态码
    const res = response.data;
    if (res.code !== 1) {
      // 假设服务器返回的状态码不是200表示有错误
      if (res.code === 401) {
        // 未授权，重定向到登录页面
        router.push("/login");
      }
      MessageBox({
        title: "提示",
        message: res.msg,
        confirmButtonText: '确定',
      })
      .then(res => {
        console.log(res)
        return false
      })
    } else {
      return res;
    }
  },
  (error) => {
    // 错误提示
    let msg = "";
    if (error.response) {
      switch (error.response.status) {
        case 400:
          msg = "请求错误";
          break;
        case 401:
          msg = "未授权，请登录";
          // 未授权，重定向到登录页面
          router.push("/login");
          break;
        case 403:
          msg = "拒绝访问";
          break;
        case 404:
          msg = `请求地址出错: ${error.response.config.url}`;
          break;
        case 500:
          msg = "服务器内部错误";
          break;
        default:
          msg = `连接错误 ${error.response.status}`;
      }
    } else {
      msg = "连接到服务器失败";
    }
    MessageBox({
      title: "提示",
      message: msg,
      confirmButtonText: '确定',
    })
    .then(res => {
      console.log(res)
      return false
    })
    return Promise.reject(error);
  }
);

// 封装GET请求方法
export const get = (url, params, config = {}) => {
  return service({
    method: "get",
    url,
    params,
    ...config,
  });
};

// 封装POST请求方法
export const post = (url, data, config = {}) => {
  return service({
    method: "post",
    url,
    data,
    ...config,
  });
};
